import {
  ON_CLICK_MEDIA,
  SET_EXPAND_STATE,
  UPDATE_STORY_PROGRESS,
  SET_APP_STATE,
  SET_POSTS,
  SET_STORIES,
  ON_TEXT_CHANGE,
  SET_BASE_URL,
  IS_FIRST_LOAD,
  SET_COMMENTS,
  SET_MEDIA_LINKS,
  SET_COMMENTS_PAGING,
  SET_CURRENT_MUTE,
  SET_CURRENT_PLAY,
  SET_CURRENT_VIDEO_REF,
  SET_CURRENT_VIDEO_ALBUM_REF,
  SET_VIDEO_FULLSCREEN,
} from '../../constants';
import { GALLERY_TYPES } from '../../constants/proGalleryConstants';
import { SORT_HASHTAG_OPTIONS } from '../../constants/settingsConstants';
import { getMediaLinks } from '../services/linksService';
import { getCommentsByMediaId } from '../services/commentsService';
import { loadMoreMedias } from './expandLoadMore';
import { createDataForLinksAndComments } from '../more/utils';
import { getMediaId } from '../../components/expand/expandUtils/expandUtils';
import store from '../../store';
import { EXPAND_PARAMS, isInstagramV4 } from '../more/migration';
import WixService from '../services/WixService';

const DEMO_STORIES = require('../templates/demoStories.json');

export const setPosts = () => ({
  type: SET_POSTS,
});

export const setStories = () => ({
  type: SET_STORIES,
});

export const openExpandMedia = ({
  eData = { idx: 0 },
  type = GALLERY_TYPES.FEED,
  isNewWindow = true,
  route = 'expand',
}) => async () => {
  const storeState = store.getState();
  const {
    accessToken,
    userId,
    isBusinessApp,
    medias,
    user,
    hashtagsData,
    paginationMedias,
    hashtags,
    defaultHashtags,
    stories,
    isConnected,
  } = storeState.appReducer;
  const mediasByType = {
    [GALLERY_TYPES.HASHTAG]: hashtagsData,
    [GALLERY_TYPES.FEED]: medias,
    [GALLERY_TYPES.STORY]:
      stories && stories.length
        ? stories
            .map((media) => ({
              ...media,
              progress: 0,
            }))
            .reverse()
        : DEMO_STORIES,
  };
  const pageByType = {
    [GALLERY_TYPES.HASHTAG]: hashtags.length === 0 ? defaultHashtags : hashtags,
    [GALLERY_TYPES.FEED]: paginationMedias,
    [GALLERY_TYPES.STORY]: {},
  };
  const { sortHashtagsFeed } = storeState.settingsReducer;
  const isRecent = sortHashtagsFeed === SORT_HASHTAG_OPTIONS.MOST_RECENT;
  const isHashtagMedias = type === GALLERY_TYPES.HASHTAG;
  const localState = {
    ...storeState.expandReducer,
    accessToken,
    userId,
    isBusinessApp,
    isHashtagMedias,
    user,
    isRecent,
    medias: mediasByType[type],
    pagination: pageByType[type],
    stories: mediasByType[GALLERY_TYPES.STORY],
    posts: medias,
    isConnected,
  };

  localState.currentIndex = eData.idx;
  localState.currentMedia =
    localState.medias[localState.currentIndex].originalData ||
    localState.medias[localState.currentIndex];
  localState.appReducer = storeState.appReducer;
  localState.settingsReducer = storeState.settingsReducer;
  const settingsReducer = storeState.settingsReducer;
  const isV4 = await isInstagramV4(settingsReducer);
  if (isV4) {
    EXPAND_PARAMS.forEach((param) => {
      localState[param] = settingsReducer[param];
    });
  }

  const url = `${window.location.protocol}//${window.location.hostname}/ig_business_app/${route}`;

  const position = {
    origin: window.Wix.WindowOrigin.FIXED,
    placement: window.Wix.WindowPlacement.CENTER,
    x: 0,
    y: 0,
  };
  localStorage.setItem('state', JSON.stringify(localState));
  isNewWindow &&
    window.Wix.openPopup(
      url,
      '100%',
      '100%',
      position,
      () => {},
      window.Wix.Theme.BARE,
    );
};

/**
 * Updates story progress by index
 * @param {number} storyIndex
 * @param {number} progress
 */
export const updateStoryProgress = (storyIndex, progress) => {
  return {
    type: UPDATE_STORY_PROGRESS,
    storyIndex,
    progress,
  };
};

/**
 * When load expand get all data
 * @param {Function} dispatch
 */
export const onLoadExpand = () => (dispatch) => {
  const state = JSON.parse(localStorage.getItem('state'));
  localStorage.removeItem('state');
  const onFirstLoad = true;
  const {
    isBusinessApp,
    medias,
    comments,
    currentIndex,
    commentsPagination,
    loadingComments,
    accessToken,
    userId,
    mediaLinks,
    loadingMediaLinks,
    isHashtagMedias,
    isConnected,
  } = state;
  const mediaId = getMediaId(currentIndex, medias);
  dispatch({
    type: SET_APP_STATE,
    payload: state.appReducer,
  });
  dispatch({
    type: ON_TEXT_CHANGE,
    payload: state.settingsReducer,
  });

  WixService.getBaseUrl()
    .then((payload) => {
      dispatch({
        type: SET_BASE_URL,
        payload,
      });
    })
    .catch((err) => console.log('Err in fetching base url', err));
  // delete state.appReducer;
  dispatch({
    type: SET_EXPAND_STATE,
    payload: state,
  });

  const isUpdatedFromStorage = updateFromStorage(
    mediaId,
    isBusinessApp,
    isConnected,
  )(dispatch);

  dispatch({
    type: IS_FIRST_LOAD,
    payload: true,
  });

  if (onFirstLoad && Object.keys(state.mediaLinks).length) {
    return;
  }

  if (!isHashtagMedias && !isUpdatedFromStorage) {
    _getExpandMediasDetails(
      dispatch,
      medias,
      comments,
      currentIndex,
      commentsPagination,
      loadingComments,
      accessToken,
      userId,
      isBusinessApp,
      mediaLinks,
      loadingMediaLinks,
      isConnected,
      onFirstLoad,
    );
  }
};

/**
 * Handling next arrow clicking.
 * @param {Function} dispatch
 * @param {Object} state
 */
export const onClickNextArrow = (dispatch, state) => {
  const {
    medias,
    currentIndex,
    pagination,
    isLodingMedias,
    accessToken,
    userId,
    isHashtagMedias,
    isBusinessApp,
    isRecent,
  } = state;

  const newIndex = currentIndex + 1;

  if (currentIndex >= medias.length) return;

  _updateCurrentMedia(dispatch, newIndex, state);

  loadMoreMedias(
    dispatch,
    newIndex,
    pagination,
    medias,
    isLodingMedias,
    accessToken,
    userId,
    isHashtagMedias,
    isBusinessApp,
    isRecent,
  );
};

/**
 * Handling swiping.
 * @param {Function} dispatch
 * @param {Object} state
 */
export const updateMediaOnSwipe = (state, index) => (dispatch) => {
  if (index < 0) return;
  _updateCurrentMedia(dispatch, index, state);
};

/**
 * Handling prev arrow clicking.
 * @param {Function} dispatch
 * @param {Object} state
 */
export const onClickPrevArrow = (dispatch, state) => {
  const newIndex = state.currentIndex - 1;
  if (newIndex < 0) return;
  _updateCurrentMedia(dispatch, newIndex, state);
};

export const updateCurrentMedia = (index) => (dispatch) => {
  const storeState = store.getState();
  const { medias } = storeState.expandReducer;
  const newMedia = medias[index].originalData || medias[index];

  dispatch({
    type: ON_CLICK_MEDIA,
    payload: {
      media: newMedia,
      index,
    },
  });
};

/**
 * Update media Selected
 * @param {Function} dispatch
 * @param {Number} newIndex - index of media
 * @param {Object} state
 */
const _updateCurrentMedia = (dispatch, newIndex, state) => {
  const {
    medias,
    comments,
    isBusinessApp,
    commentsPagination,
    loadingComments,
    accessToken,
    userId,
    mediaLinks,
    loadingMediaLinks,
    isHashtagMedias,
    isConnected,
    allCommentsLoaded,
    allMediaLinksLoaded,
  } = state;

  const newMedia = medias[newIndex].originalData || medias[newIndex];

  dispatch({
    type: ON_CLICK_MEDIA,
    payload: {
      media: newMedia,
      index: newIndex,
    },
  });

  const onFirstLoad = false;
  if (!isHashtagMedias) {
    _getExpandMediasDetails(
      dispatch,
      medias,
      comments,
      newIndex,
      commentsPagination,
      loadingComments,
      accessToken,
      userId,
      isBusinessApp,
      mediaLinks,
      loadingMediaLinks,
      isConnected,
      onFirstLoad,
      allCommentsLoaded,
      allMediaLinksLoaded,
    );
  }
};

/**
 * When open expand check that has comments and links to all medias
 * @param {Function} dispatch
 * @param {Object} medias
 * @param {Object} comments
 * @param {Number} currentIndex
 * @param {Object} commentsPagination
 * @param {Object} loadingComments
 * @param {String} accessToken
 * @param {Number} userId
 * @param {Boolean} isBusinessApp
 * @param {Object} mediaLinks
 * @param {Object} loadingMediaLinks
 */
const _getExpandMediasDetails = (
  dispatch,
  medias,
  comments,
  currentIndex,
  commentsPagination,
  loadingComments,
  accessToken,
  userId,
  isBusinessApp,
  mediaLinks,
  loadingMediaLinks,
  isConnected,
  onFirstLoad = false,
  allCommentsLoaded,
  allMediaLinksLoaded,
) => {
  const mediaId = getMediaId(currentIndex, medias);
  const mediaIdLookAhead = getMediaId(currentIndex + 5, medias);
  const mediaIdLookBefore = getMediaId(currentIndex - 5, medias);

  const {
    mediaIdsArr,
    mediaLinksArr,
    newIndex,
  } = createDataForLinksAndComments(currentIndex, medias, mediaLinks);
  // Check if exists data 5 posts up or two posts down
  const isGetLinks =
    onFirstLoad ||
    (!onFirstLoad &&
      mediaIdsArr.length &&
      allMediaLinksLoaded &&
      (!mediaLinks[mediaIdLookAhead] || !mediaLinks[mediaIdLookBefore]));
  const isGetComments =
    onFirstLoad ||
    (!onFirstLoad &&
      mediaIdsArr.length &&
      allCommentsLoaded &&
      (!comments[mediaIdLookAhead] || !comments[mediaIdLookBefore]));

  if (isBusinessApp && isGetComments) {
    getCommentsByMediaId(
      dispatch,
      mediaId,
      commentsPagination,
      accessToken,
      userId,
      !isConnected,
      mediaIdsArr,
      comments,
    );
  }
  if (isGetLinks) {
    getMediaLinks(
      dispatch,
      mediaIdsArr,
      mediaLinksArr,
      accessToken,
      userId,
      isBusinessApp,
      isConnected,
      newIndex,
      onFirstLoad,
    );
  }
};

/**
 * When open expand check for existing links and comments on local storage
 * If exists delete it
 * Return boolean value for determining if API call is needed
 * @param {Function} dispatch
 */
const updateFromStorage = (mediaId, isBusinessApp, isConnected) => (
  dispatch,
) => {
  if (!isConnected) return;
  const expandDataStorage = JSON.parse(localStorage.getItem('expandData'));
  localStorage.removeItem('expandData');
  if (!expandDataStorage) return false;
  expandDataStorage.mediaLinks = expandDataStorage.mediaLinks || {};
  expandDataStorage.comments = expandDataStorage.comments || {};
  const commentsArray = Object.keys(expandDataStorage.comments);
  const linksArray = Object.keys(expandDataStorage.mediaLinks);
  let isUpdateStorage = false;
  if (isBusinessApp && commentsArray.length) {
    dispatch({
      type: SET_COMMENTS,
      payload: expandDataStorage.comments,
    });
    dispatch({
      type: SET_COMMENTS_PAGING,
      payload: expandDataStorage.commentsPagination,
    });
    isUpdateStorage = commentsArray.indexOf(mediaId) > -1;
  }
  if (linksArray.length) {
    dispatch({
      type: SET_MEDIA_LINKS,
      payload: expandDataStorage.mediaLinks,
    });
    isUpdateStorage = linksArray.indexOf(mediaId) > -1;
  }
  return isUpdateStorage;
};

export const setVideoRef = (ref) => (dispatch) => {
  dispatch({ type: SET_CURRENT_VIDEO_REF, payload: ref });
};

export const setVideoAlbumRef = (ref, index) => (dispatch) => {
  dispatch({ type: SET_CURRENT_VIDEO_ALBUM_REF, payload: { [index]: ref } });
};

export const toggleMute = (isMute) => (dispatch) => {
  dispatch({ type: SET_CURRENT_MUTE, payload: !isMute });
};

export const setMute = (isMute) => (dispatch) => {
  dispatch({ type: SET_CURRENT_MUTE, payload: isMute });
};

export const togglePlay = (isPlay) => (dispatch) => {
  dispatch({ type: SET_CURRENT_PLAY, payload: !isPlay });
};

export const setPlay = (isPlay) => (dispatch) => {
  dispatch({ type: SET_CURRENT_PLAY, payload: isPlay });
};

export const setVideoFullscreen = (isFullscreen) => (dispatch) => {
  dispatch({ type: SET_VIDEO_FULLSCREEN, payload: isFullscreen });
};

// const onVideoClick = (refIndex, isPlay) => {
//   if (isStory) {
//     isPlay ? onPauseClick() : onPlayClick();
//   } else {
//     const current = videoRefs.current[refIndex];
//     current && (isPlay ? current.pause() : current.play());
//     togglePlay((prev) => !prev);
//   }
// };
